import type evEnums from "./index";

export type EvEnums = typeof evEnums;

//CREDITS
export type StateOrderType =
  (typeof evEnums.CREDITS.StateOrder)[keyof typeof evEnums.CREDITS.StateOrder]["Name"];

//EVALUATION
export type EvaluationStatusType =
  (typeof evEnums.EVALUATION.EvaluationStatus)[keyof typeof evEnums.EVALUATION.EvaluationStatus]["Name"];

export type PersonComponentStatusType =
  (typeof evEnums.EVALUATION.PersonComponentStatus)[keyof typeof evEnums.EVALUATION.PersonComponentStatus]["Name"];

export type TestType = keyof typeof evEnums.EVALUATION.TestTypeEnum;

//PROCESS
export type ProcessPaymentType =
  (typeof evEnums.PROCESS.ProcessPaymentTypeEnum)[keyof typeof evEnums.PROCESS.ProcessPaymentTypeEnum]["Name"];

export type ProcessPersonStatusType =
  (typeof evEnums.PROCESS.ProcessPersonStatus)[keyof typeof evEnums.PROCESS.ProcessPersonStatus]["Name"];

export type ProcessStatusType =
  (typeof evEnums.PROCESS.ProcessStatus)[keyof typeof evEnums.PROCESS.ProcessStatus]["Name"];

export type ProductType =
  (typeof evEnums.PROCESS.ProductType)[keyof typeof evEnums.PROCESS.ProductType]["Name"];

//PEOPLE
export enum PhoneTypes {
  MOBILE = "MOBILE",
}
